export interface TablePaginationState {
  length: number;
  pageIndex: number;
  pageSize: number;
  sortBy: string;
  sortDirection: Order;
}

export const DEFAULT_PAGINATION_STATE: TablePaginationState = {
  length: 0,
  pageIndex: 0,
  pageSize: 20,
  sortBy: 'id',
  sortDirection: 'desc',
};

export interface PagedResponse<T> {
  content: T[];
  totalSize: number;
}

export type Order = 'asc' | 'desc' | '';
